import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import { getToken } from "../storage/Storage";
import bhashini_logo from "../images/bhashini_logo.png";
import iiit_logo from "../images/iiit_logo.jpeg";

export default function Navbar() {
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    let mounted = true;
    // getToken is async; check token validity and update state
    (async () => {
      try {
        const token = await getToken();
        if (mounted) setSignedIn(!!token);
      } catch (err) {
        if (mounted) setSignedIn(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <nav className="landing-navbar">
      <div className="landing-nav-inner">
        <Link to="/" className="landing-logo">
          <img src={iiit_logo} alt="IIIT-H logo" className="iiit-logo" />
          <img src={bhashini_logo} alt="Bhashini logo" className="bhashini-logo" />
          <span className="landing-logo-text">Drishti Library</span>
        </Link>
        <div className="landing-nav-links">
          <Link to="/about">About</Link>
          {signedIn ? (
            <Link to="/dashboard" className="navbar-btn navbar-btn-primary">
              Dashboard
            </Link>
          ) : (
            <Link to="/signin" className="navbar-btn navbar-btn-outline">
              Sign In
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}